import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ClickAwayListener, Popper } from "@mui/material";
import { styled } from "@mui/material/styles";
import BryxColors from "../types/theme";
import BryxBox from "./BryxBox";
import BryxChip from "./BryxChip";
import BryxDatepicker from "./BryxDatepicker";
import BryxErrorText from "./BryxErrorText";
import BryxTimeInput from "./BryxTimeInput";
import { useState } from "react";
const BryxChipChip = styled((props) => _jsx(BryxChip, { ...props }))(({ theme, open, disabled, error }) => {
    const mode = theme.palette.mode;
    return {
        minWidth: "99px",
        backgroundColor: open ? BryxColors.brand3(mode) : "unset !important",
        border: `1px solid ${!disabled ? (error ? BryxColors.notify(mode, "error") : BryxColors.brandPrimary(mode)) : BryxColors.notify(mode, "inactive")}`,
        color: !disabled ? (error ? BryxColors.notify(mode, "error") : BryxColors.brandPrimary(mode)) : BryxColors.notify(mode, "inactive"),
        "&:hover": {
            backgroundColor: BryxColors.brand3(mode),
            border: `1px solid ${BryxColors.brand1(mode)}`,
            boxShadow: "none",
            "& *": {
                // This is for BryxTimeChip (or any other colored element/text within a chip)
                color: BryxColors.brand1(mode),
            },
        },
        "& span": {
            // This is for BryxTimeChip specifically to cover labels that contain a <span>
            color: error ? BryxColors.notify(mode, "error") : BryxColors.brandDark2(mode),
        },
        "&.Mui-disabled": {
            color: `${BryxColors.notify(mode, "inactive")} !important`,
            border: `1px solid ${BryxColors.notify(mode, "inactive")}`,
        },
    };
});
const BryxTimeChip = styled((props) => {
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClickAway = () => {
        setAnchorEl(null);
        setOpen(false);
    };
    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
        setOpen(!open);
    };
    return (_jsx(ClickAwayListener, { onClickAway: handleClickAway, children: _jsxs(BryxBox, { sx: { transition: "0ms" }, children: [_jsx(BryxChipChip, { sx: { transition: "0ms" }, disabled: props.disabled, open: open, on: open, error: typeof props.error != "undefined", onClick: handleClick, label: _jsxs("div", { children: [props.label, _jsx("br", {}), _jsx("span", { children: props.time?.format("HH:mm:ss") })] }), className: props.className }), _jsx(BryxErrorText, { error: props.error }), _jsxs(Popper, { id: open ? "simple-popper" : undefined, open: open, placement: "bottom", anchorEl: anchorEl, sx: { filter: "drop-shadow(0px 5px 10px rgba(50, 50, 0, 0.25)) !important", width: "198px" }, disablePortal: true, modifiers: [
                        { name: "flip", enabled: false },
                        { name: "preventOverflow", enabled: false },
                    ], children: [_jsx(BryxBox, { sx: {
                                bgcolor: "background.paper",
                                "-webkit-clip-path": "polygon(50% 0%, 0% 100%, 100% 100%)",
                                clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)",
                                background: "background.paper",
                                width: "4em",
                                height: "25px",
                                marginLeft: "auto",
                                marginRight: "auto",
                                marginTop: "1em",
                                transform: "translateY(1px)",
                            } }), _jsxs(BryxBox, { isFlex: true, column: true, mdGap: true, sx: {
                                pt: 1,
                                pb: 4,
                                px: 2,
                                bgcolor: "background.paper",
                                borderRadius: "4px",
                                boxShadow: null,
                                "& .MuiFormControl-root": { paddingTop: "8px" },
                            }, children: [_jsx(BryxDatepicker, { onChange: props.onChangeDate, value: props.time }), _jsx(BryxTimeInput, { onChange: props.onChangeDate, value: props.time })] })] })] }) }));
})(({ theme }) => {
    return {
    // Custom label styling is within BryxChip covering <span>s
    };
});
export default BryxTimeChip;
